import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { BOOKING_FORM_STATUS, BOOKING_AS } from "../../../config/constant";
import {
    setIsCorporateFlow,
    setEntity,
    setShowSaveAndPreview,
} from "../new-booking-form.slice";
import { useEffect } from "react";

export function useHandleRedirection() {
    const { oppId } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { applicantData, applicantEditPreview, showSaveAndPreview } = useSelector(
        (state) => state.newBookingForm
    );

    const handleRedirection = (res, signUserStatus) => {
        const redirect = (path) => {
            if (currentPath !== path) {
                history.push(path);
            }
        };
        if (!res || !applicantData) return; // Avoid flicker until both are loaded

        const { rating, bookingFormStatus, formSignedAt, isAgreedOnTerms, signedPdf: applicantDataSignedPdf } =
            applicantData;
        const {
            signedPdf: ressignedPdf,
            bookingFormStatus: resBookingStatus,
            leegalityData,
            rating: resRating,
            isAgreedOnTerms: resIsAggreedOnTerms,
        } = res;
        const signedPdf = ressignedPdf || applicantDataSignedPdf
        const currentPath = history.location.pathname;
        const Formstatus = resBookingStatus || bookingFormStatus;

        if (applicantData?.bookingAs) {
            dispatch(
                setIsCorporateFlow(applicantData?.bookingAs === BOOKING_AS.CORPORATE)
            );

            dispatch(
                setEntity(
                    applicantData?.bookingAs === BOOKING_AS.PARTNERSHIP_FIRM
                        ? t("entity.firm")
                        : t("entity.company")
                )
            );
        }
        
        if(res && res?.bookingFormStatus === BOOKING_FORM_STATUS.IN_PROGRESS && !applicantEditPreview && res?.isAgreedOnTerms){
             redirect(`/customer-preview/${oppId}`);
                return;
        }
        // 1. Booking form in progress
        if (Formstatus === BOOKING_FORM_STATUS.IN_PROGRESS) {
            if (isAgreedOnTerms === null || (res && (resIsAggreedOnTerms === null || resIsAggreedOnTerms === false)  )) {
                redirect(`/booking-form/${oppId}`);
                return;
            }
            if (applicantEditPreview) {
                redirect(`/booking-form/${oppId}`);
                return;
            }
            if (!applicantEditPreview) {
                redirect(`/customer-preview/${oppId}`);
                return;
            }
        }

        // 2. Feedback if signed but no rating
        if (
            (formSignedAt ||
                resBookingStatus === BOOKING_FORM_STATUS ||
                bookingFormStatus === BOOKING_FORM_STATUS.SIGNED) &&
            !rating
        ) {
            redirect(`/feedback/${oppId}`);
            return;
        }

        // 3. Thank-you if already signed or rating exists

        if (signedPdf || rating || resRating) {
            redirect(`/thank-you/${oppId}`);
            return;
        }

        // 4. Preview if partially signed or offline signed
        if (
            signedPdf === null &&
            (leegalityData?.isSignLater ||
                [
                    BOOKING_FORM_STATUS.PARTIALLY_SIGNED,
                    BOOKING_FORM_STATUS.NOT_SIGNED,
                    BOOKING_FORM_STATUS.SIGNED_OFFLINE
                ].includes(bookingFormStatus))
        ) {
            redirect(`/customer-preview/${oppId}`);
            return;
        }

        if (signUserStatus === BOOKING_FORM_STATUS?.SIGNED) {
            redirect(`/feedback/${oppId}`)
        }
    };

    useEffect(() => {
        if (applicantData && showSaveAndPreview && !applicantData?.isAgreedOnTerms) {
            dispatch(setShowSaveAndPreview(false))
        }
    }, [applicantData])

    return { handleRedirection };
}
